import React, { Component } from 'react'

export default class EvacuationDirectory extends Component {
  render() {
    return (
      <div>Directory</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/evacuation/evacuation-directory/index.js